import React from 'react';

export const changeDescription = (
  <div>
    <h3 className="vads-u-font-size--h5">Changes in behavior at work</h3>
    <p>
      Please tell us about any issues you’ve had at work as a result of the
      event. You may have experienced some or none of these. (Please check any
      that apply.)
    </p>
  </div>
);
